import { ModalController } from "@ionic/angular";
import { Component, Input, OnInit } from "@angular/core";
import { CalendarComponentOptions, CalendarModalOptions } from "ion2-calendar";

@Component({
  selector: 'date-range-picker',
  templateUrl: './date-range-picker.component.html',
  styleUrls: ['./date-range-picker.component.scss'],
})

export class DateRangePicker implements OnInit {

  constructor(private modalCtrl: ModalController,) { }

  @Input() selectedDate?: any;
  @Input() optionsRange?: CalendarComponentOptions | CalendarModalOptions;
  @Input() headerTitle?: string;

  ngOnInit(): void {

  }

  cancel() {
    this.modalCtrl.dismiss();
  }

  apply() {
    this.modalCtrl.dismiss({
      'selectedDate': this.selectedDate
    });
  }

  onCancel() {
    this.modalCtrl.dismiss({
      'selectedDate': this.selectedDate
    });
  }

  datePickerHeader() {
    // console.debug("date picker options : ", this.optionsRange, this.selectedDate)
    let _pickMode = this.optionsRange?.pickMode;
    if(this.headerTitle) return this.headerTitle;
    else if(_pickMode == 'single') return 'Pick a single date';
    else if(_pickMode == 'range') return 'Pick a range date';
  }

}
